/* tslint:disable */
/* eslint-disable */
/**
 * Melco ControlCenter APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ControlcenterMelcoModelsCustomWarning,
    ControlcenterMelcoModelsCustomWarningFromJSON,
    ControlcenterMelcoModelsCustomWarningFromJSONTyped,
    ControlcenterMelcoModelsCustomWarningToJSON,
    ControlcenterMelcoModelsSupplier,
    ControlcenterMelcoModelsSupplierFromJSON,
    ControlcenterMelcoModelsSupplierFromJSONTyped,
    ControlcenterMelcoModelsSupplierToJSON,
} from './';

/**
 * 
 * @export
 * @interface ControlcenterMelcoModelsGenericList1MelcoModelsSupplier
 */
export interface ControlcenterMelcoModelsGenericList1MelcoModelsSupplier {
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsSupplier>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSupplier
     */
    list: Array<ControlcenterMelcoModelsSupplier>;
    /**
     * 
     * @type {Array<ControlcenterMelcoModelsCustomWarning>}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSupplier
     */
    warning_list?: Array<ControlcenterMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof ControlcenterMelcoModelsGenericList1MelcoModelsSupplier
     */
    total: number;
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSupplierFromJSON(json: any): ControlcenterMelcoModelsGenericList1MelcoModelsSupplier {
    return ControlcenterMelcoModelsGenericList1MelcoModelsSupplierFromJSONTyped(json, false);
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSupplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlcenterMelcoModelsGenericList1MelcoModelsSupplier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(ControlcenterMelcoModelsSupplierFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(ControlcenterMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function ControlcenterMelcoModelsGenericList1MelcoModelsSupplierToJSON(value?: ControlcenterMelcoModelsGenericList1MelcoModelsSupplier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(ControlcenterMelcoModelsSupplierToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(ControlcenterMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


